import './Recipes.css';
import React from "react";
import recipeList from "../assets/constants/recipeList.js";

function Recipes() {

    return (
        <div className="recipeScreen">
        {recipeList.map((recipe, index) => (
                  <div className="noodleObject" key={index}>
                  </div>
                  ))}
        </div>
    )
}

export default Recipes;